import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import CancellationForm from './CancellationForm';

const CancelInsuranceStep: FC = observer(() => (
  <Box sx={{ width: '100%' }}>
    <Box>
      <Typography sx={{ mt: 2 }} variant="h4">
        Wie kündige ich meine alte Haushaltsversicherung?
      </Typography>
      <Typography sx={{ mt: 2 }}>
        Haushaltsversicherungen haben oft eine lange Laufzeit (10 Jahre).
        Bereits nach einer dreijährigen Versicherungszeit können Sie als
        Konsument aber den Versicherungsvertrag (§ 8 Abs. 3 VersVG) kündigen
        bzw. haben Sie dann jährlich, mit einer Frist von 1 Monat, das Recht zur
        Kündigung.
      </Typography>

      <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
        Kündigung bei Wohnungswechsel:
      </Typography>
      <Typography>
        Der Vertrag muss vor dem Umzug, mit Wirkung auf den Tag vor Beginn des
        Umzugs, schriftlich gekündigt werden. Anderenfalls geht die Deckung auf
        die neue Wohnung über. Als Nachweis für den Umzug gilt der Meldezettel.
        Dies gilt nicht bei Verträgen, die vor 1989 abgeschlossen wurden, hier
        ist ein Umzug innerhalb Österreichs kein Kündigungsgrund. Geben Sie
        Ihren Haushalt zur Gänze auf, fällt das versicherte Interesse weg (z.B.
        Umzug ins Ausland) und es besteht eine vorzeitige Auflösungsmöglichkeit.
        Beachten Sie aber, dass die Versicherungsgesellschaft im Falle der
        vorzeitigen Kündigung etwaige Verwaltungskosten zurückfordern kann.
      </Typography>

      <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
        Kündigung zum Vertragsablauf:
      </Typography>
      <Typography>
        Sie können zum Ablauf der vereinbarten Laufzeit und danach jährlich
        Ihren Vertrag jedenfalls kündigen. Achten Sie darauf, dass die Kündigung
        spätestens einen Monat vor Ablaufdatum bei der Versicherung einlangt.
      </Typography>

      <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
        Kündigung nach Schadenfall:
      </Typography>
      <Typography>
        Im Schadenfall können Sie aber auch der Versicherer unter Umständen den
        Vertrag kündigen. Diese sind in den Versicherungsbedingungen festgelegt.
      </Typography>
    </Box>

    <CancellationForm />
  </Box>
));

export default CancelInsuranceStep;
